import { connect, ConnectedProps } from "react-redux";
import { IStoreState } from "../../../../../reducers/types";
import { updateUserPassenger } from "../../../actions/actions";
import {
  getUserPassengerCallState,
  getUserPassengers,
  getIsHertzProvider,
} from "../../../reducer";
import { getCarShopSelectedVehicle } from "../../../../shop/reducer";
import { getCorporateInfo } from "../../../../rewards/reducer/selectors";
import { DriverSelectDropdownForm } from "./component";

const mapStateToProps = (state: IStoreState) => {
  return {
    travelers: getUserPassengers(state),
    userPassengerCallState: getUserPassengerCallState(state),
    isHertzProvider: getIsHertzProvider(state),
    selectedVehicle: getCarShopSelectedVehicle(state),
    userRoles: getCorporateInfo(state)?.role,
  };
};

const mapDispatchToProps = {
  updateUserPassenger,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type DriverSelectDropdownFormConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedDriverSelectDropdownForm = connector(
  DriverSelectDropdownForm
);
